import React, { useState, useEffect } from 'react'
import {
  Panel,
  IconButton,
  Icon,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Input,
  Message,
} from 'rsuite'
import { Grid, Row, Col } from 'rsuite'
import { useHistory, useParams } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveNotAccepted } from '../../redux/actions/notAccepted'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ReviewSummary(props) {
  const { showCommandButton, isEditAll } = props
  const [formSchema, setFormSchema] = useState(props.schema)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const _schema = await saveNotAccepted(request)
      doneLoading()
      const _projectVersionId =
        _schema.projectVersionId || _schema.model?.projectVersionId || projectId

      sessionStorage.setItem('projectId', _projectVersionId)
      sessionStorage.setItem('param', '')
      return history.push(`${pathname.proposal.overview.overviewCoworker}`)
    } catch (error) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    setIsShowConfirm(true)
  }

  const onConfirm = (data) => {
    const request = {
      projectVersionId: projectId,
      form: {
        name: 'comment',
        value: data.comment,
        label: 'ความคิดเห็น/เหตุผล',
        hint: 'ระบุความคิดเห็น/เหตุผล',
        enable: true,
        buttonText: 'บันทึกความคิดเห็น/เหตุผล',
      },
    }

    setIsShowConfirm(false)
    handleCallService(request)
  }

  const onCancle = () => {
    setIsShowConfirm(false)
  }

  return (
    <>
      <Panel
        header={formSchema.topic}
        collapsible
        defaultExpanded
        shaded
        bordered
        style={{ marginBottom: '20px' }}
      >
        <Form fluid>
          <ControlLabel>{requiredFiled(formSchema.validators, formSchema.form.label)}</ControlLabel>
          <ErrorMessage error={errors[formSchema.form.name]} />
          <br />
          <Input
            name={formSchema.form.name}
            inputRef={register(isValidators(formSchema.validators))}
            rows={5}
            placeholder={formSchema.form.hint || `ระบุ${formSchema.form.label}`}
            // disabled={formSchema.form.enable}
            componentClass="textarea"
          />
        </Form>
        <hr />
        {isError && (
          <div style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'}
            />
          </div>
        )}
        <IconButton
          appearance="ghost"
          icon={<Icon appearance="ghost" icon="save" className="bt-gost-icon-radius" />}
          onClick={handleSubmit(onSubmit)}
        >
          {formSchema.form.buttonText}
        </IconButton>

        <ConfirmWidget
          title={`ยืนยันการบันทึกความคิดเห็น/เหตุผล`}
          show={isShowConfirm}
          detail={`กรุณายืนยันการบันทึกผลส่งความคิดเห็น/เหตุผล`}
          onCancle={onCancle}
          onConfirm={handleSubmit(onConfirm)}
        />
      </Panel>
    </>
  )
}
